import React from 'react';

interface DriveOutlineIconProps {
  size?: number;
  color?: string;
}

const DriveOutlineIcon: React.FC<DriveOutlineIconProps> = ({
  size = 20,
  color = 'currentColor',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#drive-outline-clip)">
        <path
          d="M17.8571 7.85718H10.7142C9.92524 7.85718 9.28564 8.49678 9.28564 9.28575V17.8572C9.28564 18.6462 9.92524 19.2857 10.7142 19.2857H17.8571C18.6461 19.2857 19.2856 18.6462 19.2856 17.8572V9.28575C19.2856 8.49678 18.6461 7.85718 17.8571 7.85718Z"
          stroke={color}
          strokeWidth="1.42857"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.1427 12.1431H16.4284"
          stroke={color}
          strokeWidth="1.42857"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.1427 15.0001H16.4284"
          stroke={color}
          strokeWidth="1.42857"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.0144 -0.00287737C6.40978 -0.0101662 6.7972 0.114765 7.11234 0.354265C7.43134 0.596982 7.65745 0.941816 7.75408 1.33083L7.99404 2.28646H14.3849C14.8512 2.28665 15.2996 2.47147 15.6294 2.80125C15.959 3.13112 16.1441 3.57913 16.1441 4.04567V6.65728C16.1441 6.65728 15.9209 6.78563 15.5303 6.78563C15.1397 6.78563 14.9165 6.65728 14.9165 6.65728V4.04567C14.9165 3.9051 14.8596 3.76999 14.7602 3.67039C14.6609 3.57111 14.5255 3.51433 14.3849 3.51414H7.51413C7.23245 3.51406 6.9869 3.32279 6.91842 3.04958L6.56267 1.62938C6.53367 1.51182 6.46506 1.40561 6.36876 1.33222C6.27249 1.25906 6.15338 1.22017 6.03254 1.22341L6.0144 1.2248H1.78868C1.64816 1.2248 1.5129 1.28047 1.4134 1.37966C1.3139 1.47915 1.25723 1.61424 1.25715 1.75494V13.7792C1.25715 13.9201 1.31388 14.055 1.4134 14.1545C1.51284 14.2538 1.64797 14.3107 1.78868 14.3107H7.98788C7.98788 14.3107 8.21446 14.3981 8.21446 14.9246C8.21446 15.4511 7.98788 15.5384 7.98788 15.5384H1.78868C1.32231 15.5384 0.874267 15.3535 0.544259 15.0236C0.214279 14.6937 0.0280762 14.2459 0.0280762 13.7792V1.75494C0.0281523 1.28839 0.214371 0.840411 0.544259 0.510515C0.874165 0.180924 1.32231 -0.00427246 1.78868 -0.00427246L6.0144 -0.00287737Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="drive-outline-clip">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DriveOutlineIcon;
